import React from "react";

import { FormControlLabel, Stack, Typography } from "@mui/material";

import { formatStartAndEndTime } from "@app/common/utils";

import { Row } from "@rui/Stack";
import Switch from "@rui/Switch";
import TooltipWrapper from "@rui/TooltipWrapper";

import {
  UpcomingEventsTableRowProps,
  getCannotBeFlexibleReason,
} from "./UpcomingEventsTableRow";

interface UpcomingEventsTableRowDensContentProps
  extends UpcomingEventsTableRowProps {
  userCanInviteRead: boolean;
  isReadInvited: boolean;
  canBeFlexible: boolean;
  cannotInviteReadTooltip: React.ReactNode;
}

const UpcomingEventsTableRowDenseContent = ({
  event,
  onToggleInvite,
  onToggleFlexible,
  userCanInviteRead,
  isReadInvited,
  canBeFlexible,
  cannotInviteReadTooltip,
}: UpcomingEventsTableRowDensContentProps) => {
  return (
    <>
      <Stack>
        <Row variant="left" spacing={1}>
          <Typography variant="labelReg" color="shades.neutral.500">
            {event.startTime.weekdayShort}
            {", "}
            {event.startTime.toFormat("LLL dd")} •{" "}
            {formatStartAndEndTime(event.startTime, event.endTime)}
          </Typography>
        </Row>
        <Row>
          <FormControlLabel
            control={
              <TooltipWrapper
                show={!userCanInviteRead}
                title={cannotInviteReadTooltip}
              >
                <Switch
                  checked={userCanInviteRead && isReadInvited}
                  onChange={onToggleInvite}
                  disabled={!userCanInviteRead}
                />
              </TooltipWrapper>
            }
            label={<Typography variant="bodySecondaryReg">Add Read</Typography>}
          />

          <FormControlLabel
            control={
              <TooltipWrapper
                title={getCannotBeFlexibleReason(event)}
                show={!canBeFlexible}
              >
                <Switch
                  checked={event.isFlexible}
                  onChange={onToggleFlexible}
                  disabled={!canBeFlexible}
                />
              </TooltipWrapper>
            }
            label={<Typography variant="bodySecondaryReg">Flexible</Typography>}
          />
        </Row>
      </Stack>
    </>
  );
};

export default UpcomingEventsTableRowDenseContent;
